export enum EventTypes {
  ACCEPT = "accept",
  REJECT = "reject",
}

export default interface Event {
  type: EventTypes
  guestId: string
}
